// import { useState } from "react";
import { useEffect, useState, useContext, useRef } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

//  React components
import MDBox from "components/MDBox";
// import MDButton from "components/MDButton";

//  React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import FormField from "./components/FormField";
import { Autocomplete } from "@mui/material";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { NavLink, useNavigate, useParams } from "react-router-dom";

import { v4 as uuidv4 } from "uuid";

const axios = require("axios").default;
import { DataContext } from "context/dataContext";
import ErrorText from "components/ErrorText";

const EditSession = () => {
  const params = useParams();

  const { dataState, getSingleSessionApi, updateSessionApi } = useContext(DataContext);
  const navigate = useNavigate();
  const [audio_file, setAudioFile] = useState(null);
  const [playerfile, setPlayerFile] = useState(null);

  const sessionRef = useRef();

  const [value, setValue] = useState({
    name: "",
    slug: "",
    session_type: "Audio",
    duration: "",
    description: "",
    key: "",
    index: null,
  });

  const [errors, setErrors] = useState({
    name: "",
    slug: "",
    session_type: null,
    duration: "",
    description: "",
  });

  const uuidvNumbers = () => {
    const uuid = uuidv4();
    const uuidFinal = uuid.replace(/\D/g, "").slice(0, 12);
    return Number(uuidFinal);
  };

  const validateForm = () => {
    const newErrors = {
      name: value.name ? "" : "Name is required",
      session_type: value.session_type ? "" : "Session Type is required",
    };

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const convertToSlug = (str) => {
    //replace all special characters | symbols with a space
    str = str.replace(/[`~!@#$%^&*()_\-+=\[\]{};:'"\\|\/,.<>?\s]/g, " ").toLowerCase();

    // trim spaces at start and end of string
    str = str.replace(/^\s+|\s+$/gm, "");

    // replace space with dash/hyphen
    str = str.replace(/\s+/g, "-");

    return str;
  };

  const handleName = (e) => {
    setValue({ ...value, name: e.target.value });
  };

  const handleType = (event, newValue) => {
    setValue({ ...value, session_type: newValue });
  };

  const handelDescription = (e) => {
    setValue({ ...value, description: e.target.value });
  };

  const ResetValue = () => {
    setValue({ ...value, name: "" });
    setValue({ ...value, slug: "" });
    setValue({ ...value, description: "" });
    setValue({ ...value, duration: "" });
    setValue({ ...value, key: "" });
    setValue({ ...value, session_type: "Audio" });
    setAudioFile(null);
  };

  const handleSubmit = () => {
    if (validateForm()) {
      var genslug = convertToSlug(value.name);
      if (audio_file && genslug) {
        var session_id = params.id;
        const form = new FormData();
        form.append("id", session_id);
        form.append("slug", genslug);
        form.append("name", value.name);
        form.append("description", value.description);
        form.append("type", value.session_type);
        form.append("duration", value.duration);
        form.append("program", params.id);
        form.append("key", value.key);
        form.append("created_on", new Date());
        if (typeof audio_file !== "string") {
          form.append("file", audio_file);
        } else {
          form.append("file", null);
        }

        updateSessionApi({
          form: form,
          program: params.id,
        }).then((res) => {
          if (res.success) {
            console.log("Session updated");
            ResetValue();
          } else {
            console.log("Something went wrong");
          }
        });
      } else {
        alert("Please add audio file");
      }

      //   updateSessionApi({
      //     ...value,
      //   }).then((res) => {
      //     if (res.success) {
      //         ResetValue()
      //       //navigate("/master/items");
      //     } else {
      //       console.log("Something went wrong");
      //     }
      //   });
    }
  };

  // get old data from url
  useEffect(() => {
    let session_id = params.id;

    getSingleSessionApi(session_id).then((res) => {
      if (res.success) {
        let resData = res?.data?.data?.session;
        //console.log(resData);

        setValue({
          name: resData?.name || "",
          session_type: resData?.session_type || "Audio",
          description: resData?.description || "",
          duration: resData?.duration || "",
          slug: resData?.slug || "",
          key: resData?.key || "",
        });
        //console.log(resData.url);
        setPlayerFile(resData.url);
      } else {
        console.log("Something went wrong");
      }
    });
  }, []);

  const readFile = (file) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      // The file content is available in event.target.result
      const fileContent = event.target.result;
      console.log("File content:");
      setPlayerFile(fileContent);
      // You can now store this content in your component's state
      // or process it further.
    };

    reader.onerror = (error) => {
      console.error("Error reading file:", error);
    };

    // Choose the appropriate reading method based on the file type and desired output:
    // reader.readAsText(file); // Reads the file as a plain text string
    reader.readAsDataURL(file); // Reads the file as a data URL (useful for images)
    // reader.readAsArrayBuffer(file); // Reads the file as an ArrayBuffer
    // reader.readAsText(file); // Example: reading as text
  };

  const handleAudio = (e) => {
    console.log("file", e.target.files[0]);
    setAudioFile(e.target.files[0]);
    var file = e.target.files[0];
    const audio = document.createElement("audio");
    audio.setAttribute("src", URL.createObjectURL(file));
    audio.addEventListener("loadedmetadata", () => {
      const duration = audio.duration;
      setValue({ ...value, duration: duration });
      // do stuff with the duration
    });
    console.log(file);
    if (file) {
      // Proceed to read the file
      readFile(file);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={2} mb={2}>
        <Grid container justifyContent="center" alignItems="center" gap={2} sx={{ height: "100%" }}>
          <Grid item xs={12} lg={12}>
            <MDBox display="flex" alignItems="center" gap={2}>
              <MDButton variant="gradient" color="primary" component={NavLink} to="/master/items">
                {" "}
                Go Back{" "}
              </MDButton>
            </MDBox>
          </Grid>
          <Grid item xs={12} lg={12}>
            <Card autoComplete="off" sx={{ height: "100%" }}>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                gap={2}
                sx={{ height: "100%" }}
              >
                <MDBox p={3} pb={0}>
                  <MDTypography variant="h5">Edit - {value.name || "Session"}</MDTypography>
                </MDBox>
                <MDBox component="form" pb={2} p={3}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={5}>
                      <FormField
                        type="text"
                        label="Name"
                        value={value.name}
                        onChange={handleName}
                      />
                      {errors.name && <ErrorText errorName={errors.name} />}
                    </Grid>
                    <Grid item xs={12} md={5}>
                      <FormField type="text" disabled label="Slug" value={value.slug} />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <FormField type="text" disabled label="Duration" value={value.duration} />
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <MDBox mb={1} ml={0.5} lineHeight={0}>
                        <MDTypography
                          component="label"
                          variant="button"
                          fontWeight="regular"
                          color="text"
                        >
                          Description&nbsp;&nbsp;
                          <MDTypography variant="caption" color="text">
                            (optional)
                          </MDTypography>
                        </MDTypography>
                      </MDBox>
                      <FormField
                        type="text"
                        multiline
                        rows={1}
                        value={value.description}
                        onChange={handelDescription}
                        label="Enter description here"
                      />
                      {errors.description && <ErrorText errorName={errors.description} />}
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <MDBox mb={2} display="inline-block">
                        <MDTypography
                          component="label"
                          variant="button"
                          fontWeight="regular"
                          color="text"
                          textTransform="capitalize"
                        >
                          Type
                        </MDTypography>
                      </MDBox>
                      <Autocomplete
                        defaultValue="Audio"
                        options={["Audio"]}
                        //options={["Audio", "Text", "PDF", "Video"]}
                        value={value.session_type}
                        onChange={handleType}
                        renderInput={(params) => <MDInput {...params} variant="standard" />}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MDInput
                        type="file"
                        label="Audio File"
                        variant="standard"
                        fullWidth
                        ref={sessionRef}
                        onChange={handleAudio}
                        accept="audio/*"
                      />
                    </Grid>
                    {playerfile ? (
                      <Grid item xs={12}>
                        <audio controls>
                          <source src={playerfile} type="audio/mpeg" />
                          Your browser does not support the audio element.
                        </audio>
                      </Grid>
                    ) : (
                      <></>
                    )}

                    <Grid item xs={12}>
                      <MDButton variant="gradient" color="primary" onClick={handleSubmit}>
                        Save Session
                      </MDButton>
                    </Grid>
                  </Grid>
                </MDBox>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
};

export default EditSession;
